import { render, staticRenderFns } from "./TableInspectColumn7.vue?vue&type=template&id=4c1393fe&scoped=true"
import script from "./TableInspectColumn7.vue?vue&type=script&lang=js"
export * from "./TableInspectColumn7.vue?vue&type=script&lang=js"
import style0 from "./TableInspectColumn7.vue?vue&type=style&index=0&id=4c1393fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1393fe",
  null
  
)

export default component.exports